var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_15",
    "data-name": "Artboard \\u2013 15",
    clipPath: "url(#clip-Artboard_15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-down",
    "data-name": "Icon awesome-arrow-alt-circle-down",
    d: "M25.562,13.063a12.5,12.5,0,1,1-12.5-12.5A12.5,12.5,0,0,1,25.562,13.063ZM10.845,7.216v5.847H7.271A.605.605,0,0,0,6.843,14.1l5.791,5.761a.6.6,0,0,0,.852,0L19.277,14.1a.6.6,0,0,0-.428-1.033H15.28V7.216a.607.607,0,0,0-.6-.6H11.45A.607.607,0,0,0,10.845,7.216Z",
    transform: "translate(-0.563 25.563) rotate(-90)",
    fill: "#f5af0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/iconArrowRight.b5a0de52023ca055dfdb614c996e3a5d.svg";
export { ForwardRef as ReactComponent };